import { Navigate, Route, Routes } from 'react-router-dom';
import { ProtectedRoute } from './ProtectedRoute';
import { RoleRoute } from './RoleRoute';
import { ROUTES } from './paths';
import { AppShell } from '@/shared/layouts/AppShell';
import { LoginPage } from '@/features/auth/Login';
import { DashboardPage } from '@/features/dashboard/Dashboard';
import { LeadsPage } from '@/features/leads/pages/LeadsPage';
import { DealsPage } from '@/features/deals/pages/DealsPage';
import { ContactsPage } from '@/features/contacts/pages/ContactsPage';
import { ActivityPage } from '@/features/activity/pages/ActivityPage';
import { AnnouncementsPage } from '@/features/announcements/pages/AnnouncementsPage';
import { AIWorkspacePage } from '@/features/ai/pages/AIWorkspacePage';
import { ScraperPage } from '@/features/scraper/pages/ScraperPage';
import { CallCenterPage } from '@/features/callcenter/pages/CallCenterPage';
import { DemosPage } from '@/features/demos/pages/DemosPage';
import { SalesDocsPage } from '@/features/salesdocs/pages/SalesDocsPage';
import { NotesPage } from '@/features/notes/pages/NotesPage';
import { TasksPage } from '@/features/tasks/pages/TasksPage';
import { ProjectsPage } from '@/features/projects/pages/ProjectsPage';
import { MeetingsPage } from '@/features/meetings/pages/MeetingsPage';
import { HrPage } from '@/features/hr/pages/HrPage';
import { LeavesPage } from '@/features/hr/pages/LeavesPage';
import { AttendancePage } from '@/features/attendance/pages/AttendancePage';
import { SettingsPage } from '@/features/settings/pages/SettingsPage';
import { ReportsPage } from '@/features/reports/pages/ReportsPage';
import { NotFoundPage } from '@/shared/components/NotFound';

/**
 * Foundation routing: Login (public), a protected shell with a single
 * Dashboard placeholder, and a 404. CRM module routes are added in later steps.
 */
export function AppRouter() {
  return (
    <Routes>
      <Route path={ROUTES.login} element={<LoginPage />} />

      <Route element={<ProtectedRoute />}>
        <Route element={<AppShell />}>
          <Route path={ROUTES.root} element={<Navigate to={ROUTES.dashboard} replace />} />
          <Route path={ROUTES.dashboard} element={<DashboardPage />} />
          <Route path={ROUTES.leads} element={<LeadsPage />} />
          <Route path={ROUTES.scraper} element={<ScraperPage />} />
          <Route path={ROUTES.callCenter} element={<CallCenterPage />} />
          <Route path={ROUTES.contacts} element={<ContactsPage />} />
          <Route path={ROUTES.tasks} element={<TasksPage />} />
          <Route path={ROUTES.projects} element={<ProjectsPage />} />
          <Route path={ROUTES.demos} element={<DemosPage />} />
          <Route path={ROUTES.salesDocs} element={<SalesDocsPage />} />
          <Route path={ROUTES.notes} element={<NotesPage />} />
          <Route path={ROUTES.meetings} element={<MeetingsPage />} />
          <Route path={ROUTES.announcements} element={<AnnouncementsPage />} />
          <Route path={ROUTES.leaves} element={<LeavesPage />} />
          <Route path={ROUTES.attendance} element={<AttendancePage />} />
          <Route path={ROUTES.activity} element={<ActivityPage />} />
          <Route path={ROUTES.ai} element={<AIWorkspacePage />} />
          <Route path={ROUTES.settings} element={<SettingsPage />} />

          {/* Admin / SuperAdmin only */}
          <Route element={<RoleRoute roles={['admin', 'superadmin']} />}>
            <Route path={ROUTES.hr} element={<HrPage />} />
            <Route path={ROUTES.reports} element={<ReportsPage />} />
          </Route>

          {/* Deals — Super Admin, Admin, Employee, BDE (per role structure) */}
          <Route element={<RoleRoute roles={['superadmin', 'admin', 'employee', 'bde']} />}>
            <Route path={ROUTES.deals} element={<DealsPage />} />
          </Route>
        </Route>
      </Route>

      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
